/**
 * Product page carousel autoplay — advances slides every 15 seconds.
 *
 * Uses the built-in slideshow-component API (play / suspend / resume) so that
 * existing hover-pause and swipe behaviour continues to work unchanged.
 */
(async () => {
  const INTERVAL_MS = 15_000;

  // Only run on pages that actually have a media gallery
  if (!document.querySelector('media-gallery')) return;

  // Wait for the custom element class to be registered before touching instances
  await customElements.whenDefined('slideshow-component');

  const gallery = document.querySelector('media-gallery[data-presentation="carousel"]');
  if (!gallery) return;

  const slideshow = gallery.querySelector('slideshow-component');
  if (!slideshow) return;

  // Setting the autoplay attribute lets the built-in resume() restart the
  // timer after the user hovers away — no extra code needed for that.
  slideshow.setAttribute('autoplay', String(INTERVAL_MS));

  /**
   * Start playback. The component's play() guard returns early if the
   * interval is already running, so calling this repeatedly is safe.
   */
  function startAutoplay() {
    if (typeof slideshow.play === 'function') {
      slideshow.play(INTERVAL_MS);
    }
  }

  if (slideshow.isConnected) {
    // Component is already in the DOM; wait two animation frames so that
    // connectedCallback() and #setupSlideshow() have fully executed.
    requestAnimationFrame(() => requestAnimationFrame(startAutoplay));
  } else {
    // Component hasn't been inserted yet — observe until it is.
    const mo = new MutationObserver(() => {
      if (slideshow.isConnected) {
        mo.disconnect();
        requestAnimationFrame(() => requestAnimationFrame(startAutoplay));
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Safety disconnect after 10 s in case the page structure changes
    setTimeout(() => mo.disconnect(), 10_000);
  }
})();
